import React, { useRef, useState, useContext, useEffect } from 'react'
import printJS from 'print-js'
import QRCode from 'react-qr-code'
import Popup from '../../Product/components/organisms/Popup'
import Loader from '../../assets/loader'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import moment from 'moment'
import { Pagination } from '@material-ui/lab'
import AuthContext from '../../Product/context/auth/authContext'
import ProductContext from '../../Product/context/product/productContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import AlertContext from '../../Product/context/alert/alertContext'
import { handleRedirectInternal } from '../../Product/common/components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'

const RushPassHistory = () => {
    const authContext = useContext(AuthContext)
    const pluginContext = useContext(PluginContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { user } = authContext
    const { get_rushpass_list, rushpass_list } = pluginContext
    const history = useHistory()

    const [listLoading, setListLoading] = useState(false)
    const [referralist, setReferralList] = useState([])
    const [referralListCount, setReferralListCount] = useState(0)
    const [page, setPage] = useState(1)
    const [openQrModal, setOpenQrModal] = useState(false)
    const [qrValue, setQrValue] = useState(null)

    const handlePrint = () => {
        // temporarily make the print section visible before printing
        const printElement = document.getElementById('print-section')
        printElement.style.display = 'block'

        // delay to allow render before printing
        setTimeout(() => {
            printJS({
                printable: 'print-section',
                type: 'html',
                scanStyles: false, // optional, disables picking up random global CSS
            })

            // hide again after printing
            setTimeout(() => {
                printElement.style.display = 'none'
            }, 500)
        }, 100)
    }
    useEffect(() => {
        const fetchReferralList = async () => {
            if (user) {
                setListLoading(true)
                await get_rushpass_list({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    page,
                    perlimit: 10,
                })
                setListLoading(false)
            }
        }
        fetchReferralList()
    }, [user, page])

    useEffect(() => {
        if (rushpass_list?.message?.results?.length > 0) {
            setReferralList(rushpass_list.message.results)
            setReferralListCount(rushpass_list.message.results_cnt)
        } else {
            setReferralList([])
        }
    }, [rushpass_list])

    return (
        <div>
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : referralist.length > 0 ? (
                <>
                    <div className="table-responsive responisveTable mt-4 mWItems">
                        <table className="table table-hover mobile-table responisveTable ">
                            <thead className="hidden-mobile">
                                <tr>
                                    <th>Pass Code</th>
                                    <th>Pass Name</th>
                                    <th>Invoice</th>
                                    <th>Per Qty Price</th>
                                    <th>Purchase Qty</th>
                                    <th>Purchase Amount</th>
                                    <th>Total Days</th>
                                    <th>Used Days</th>
                                    <th>Paid Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {referralist.map((item, index) => (
                                    <tr key={index}>
                                        <td className="center" data-label="Pass Code">
                                            {item?.pass_code || '-'}
                                        </td>
                                        <td className="center" data-label="Pass Name">
                                            {item?.name || '-'}
                                        </td>
                                        <td className="center " data-label="Invoice">
                                            <span
                                                className="navLinkColor"
                                                onClick={() => {
                                                    if (item?.invoice_id !== 0) {
                                                        handleRedirectInternal(
                                                            history,
                                                            `invoice/buynow?id=${item.invoice_id}`,
                                                        )
                                                    }
                                                }}
                                            >
                                                {item?.invoice_id || '-'}
                                            </span>{' '}
                                        </td>
                                        <td className="center" data-label="Per Qty Price">
                                            ${item?.per_price || '-'}
                                        </td>
                                        <td className="center" data-label="Purchase Qty">
                                            {item?.purchase_qty || '-'}
                                        </td>
                                        <td className="center" data-label="Purchase Amount">
                                            ${item?.purchase_amount || '-'}
                                        </td>
                                        <td className="center" data-label="Total Days">
                                            {item?.qty || '-'}
                                        </td>
                                        <td className="center" data-label="Used Days">
                                            {item?.used_qty || '-'}
                                        </td>
                                        <td className="center" data-label="Paid Date">
                                            {moment
                                                .utc(item?.date_add, 'MM/DD/YYYY hh:mm:ss A')
                                                .local()
                                                .format('dddd, MMMM DD, YYYY')}
                                        </td>
                                        <td
                                            className="center text-blue-600 cursor-pointer"
                                            data-label="Action"
                                            onClick={() => {
                                                setQrValue(item.pass_code)
                                                setOpenQrModal(true)
                                            }}
                                        >
                                            <span className="material-icons">print</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        count={Math.ceil(referralListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}

            {/* QR Code Popup */}
            <Popup
                open={openQrModal}
                handleClose={() => setOpenQrModal(false)}
                modaltitle="Pass Code"
                handleGFModal={true}
            >
                <div className="text-center p-4">
                    <QRCode
                        value={String(qrValue || '')}
                        size={160}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                    />
                </div>

                <div className="flex justify-center mt-4">
                    <PrimaryButton onClick={handlePrint}>Print</PrimaryButton>
                </div>
            </Popup>

            {/* Hidden printable content */}
            <div id="print-section" style={{ display: 'none' }}>
                <div className="text-center p-4">
                    <h2 className="text-lg font-semibold mb-2">Pass Code</h2>
                    <QRCode
                        value={String(qrValue || '')}
                        size={160}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                    />
                </div>
            </div>
        </div>
    )
}

export default RushPassHistory
